export interface UserLogin {
    email : string ,
    password : string
}

export class User {
    constructor(
    public email: string,
    public password: string) { }

}


// WEBPACK FOOTER //
// ./src/app/component/model/user-login.ts